'use strict';

import React, { useEffect, useState } from 'react'

import PageWrapper from '@Layout/PageWrapper'

import Layout from '@Layout/FrontOffice'

import FrontAuthCentered from '@/Wrapper/FrontAuthCentered'

import LoginForm from '@/Form/LoginForm'

import getFormStatus from '@/Form/Functions/getFormStatus'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'

import removeGetParameter from '@function/removeGetParameter'
import getUrlParameter    from '@function/getUrlParameter'

import { isTrue } from '@root/utility'

const { app, qwest } = window;

export default PageWrapper(function LoginPage (props)
{
	const from_logout = getUrlParameter('action', document.location.href) === 'logout';
	const auth_error  = getUrlParameter('error', document.location.href) === 'not_auth';
	const auth_token  = getUrlParameter('token', document.location.href);

	const [permissions, setPermissions] = useState('pending');
	const [show, setShow] = useState(auth_token ? 'login-form' : undefined);

	const needs_refresh = auth_error || from_logout;

	useEffect(function ()
	{
		app.push(
		{
			event: 'sessionChange',
			cb: handleSession
		});

		if (app.state.session_fetched)
		{
			handleSession();
		}
		else if (needs_refresh)
		{
			removeGetParameter('action');
			removeGetParameter('error');

			qwest.post('/get-session')
			.then(function (xhr, response)
			{
				app.state.session = response || { permissions: { title: 'not_auth' } };

				app.state.session_fetched = true;

				app.emit('sessionChange', { label: 'initState' });
			})
			.catch(function (error, xhr, response)
			{
				console.error(error);
			});
		}

		return () => { app.delete({ event: 'sessionChange', cb: handleSession }); }

		function handleSession ()
		{
			const perms = app.state.session.permissions?.title || 'not_auth';

			if (perms === 'not_auth')
			{
				setShow('login-form');
			}

			setPermissions(perms);
		}
	},
	[needs_refresh]);

	const loader = permissions === 'pending' ?
	(
		<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
	)
	: undefined;

	const content = loader ?
	(
		<div className="auth-loading">
			{ loader }
		</div>
	)
	: show === 'login-form' ?
	(
		<LoginForm className="c-form form-login"
			history={ props.history }
		/>
	)
	:
	(
		<div className="c-form form-login">

			<div className="home-tabs">
				<Link href="/login" className="c-tab c-tab--active">
					<div className="c-tab__label">Connexion</div>
				</Link>

				<Link href="/inscription" className="c-tab">
					<div className="c-tab__label">S'inscrire</div>
				</Link>
			</div>

			<div className="o-content">
				{ getFormStatus({ info: 'Vous êtes déjà connecté(e)' }) }

				<div className="u-full-width u-flex u-flex-wrap u-margin-bottom-30
					u-row-gap-20 u-col-gap-20 u-content-between">

					{
						isTrue(app.state.session?.__disabled_with_card) ?
						(
							<Link href="/accueil/mon-compte/syner-kado"
								className="c-btn c-btn--extra c-btn--green">
								Ma carte Syner'Kado
							</Link>
						)
						:
						(

							<Link href={ (permissions === 'Membre de synergies' ?
								'/dashboard' : '/accueil') }
								className="c-btn c-btn--extra c-btn--green">
								Accueil
							</Link>
						)
					}

					<button type="button" className="c-btn c-btn--primary c-btn--extra"
						onClick={ e => setShow('login-form') }>
						Me connecter à nouveau
					</button>

				</div>

			</div>

		</div>
	);

	return (
		<Layout page_title="Login">

			<FrontAuthCentered>

				<div className="home-form login">

					<div className="home-form__img-container">
						<Image className="home-form__img"
							src="/images/background/accueil_synergies@1500.jpg"
						/>
					</div>

					{ content }

				</div>

			</FrontAuthCentered>

		</Layout>
	);
});